import { formatDate } from "rant-utils";
import { ConditionalController } from "../../core/hooks/useConditional";
import { Icon } from "../../core/ui/icons";
import { TrackedItem } from "../../types";


export function TrackedItemDisplay<E,H>(props: {
	title: string,
	item: TrackedItem,
	children?: any,

	showEffective?: boolean,

	className?: string,

	edit: ConditionalController<E>,
	history: ConditionalController<H>,
}) {

	return (

		<div className="padding-5">

		{/* <fieldset className="width-100pc">
			<legend>{props.title}</legend> */}

			<div className="flex vert align-start">
				<div className="fill">
					<div className={props.className + " editable"}
						onClick={() => {
							props.edit.show({} as E);
						}}					
					>{props.children}</div>

					{
						props.item && props.item.effective && props.showEffective &&
						<div className="tag subtle">Effective {formatDate(props.item.effective)}</div>
					}
				</div>

				{/* <div className="flex vert align-start"> */}
					{/* <button
						className="flat"
						onClick={() => {
							props.edit.show({} as E);
						}}
					><Icon type="edit" size="small" /></button> */}

					<button
						className="history-button flex horiz align-center gap-2"
						onClick={() => {
							props.history.show({} as H);
						}}
					><Icon type="history" size="small" />History</button>
				{/* </div> */}
			</div>

			{props.edit.render()}
			{props.history.render()}

		{/* </fieldset> */}

		</div>

	);
}